export async function importModule() {
    return await import(/* webpackChunkName: "pdfjs-dist" */ 'pdfjs-dist/webpack');
}